import { Skeleton } from "@/components/ui/skeleton";

export const UpcomingEventsSkeleton = () => {
  return (
    <div className="h-fit overflow-hidden rounded-2xl border border-blue-200 bg-slate-50">
      {/* Header section skeleton */}
      <div className="flex w-full flex-col justify-between gap-4 bg-blue-200 px-6 py-4 lg:flex-row lg:items-center">
        <Skeleton className="h-8 w-48 rounded-md lg:h-10" />
        <Skeleton className="h-10 w-32 rounded-full" />
      </div>

      {/* Events list skeleton */}
      <ul className="[&>*:nth-child(even)]:bg-slate-50 [&>*:nth-child(odd)]:bg-white">
        {[...Array(5)].map((_, i) => (
          <li
            key={i}
            className="flex items-center border-b border-slate-100 px-6 py-3 lg:py-4"
          >
            <Skeleton className="h-6 w-full rounded-md lg:h-8" />
          </li>
        ))}
      </ul>
    </div>
  );
};
